export function isClairAdsHost(hostname = window.location.hostname) {
  return hostname === 'clairads.com' || hostname === 'www.clairads.com';
}

export function clairAdsHref(hostname = window.location.hostname) {
  if (isClairAdsHost(hostname)) return '/';
  if (hostname === 'clairlabs.io' || hostname === 'www.clairlabs.io') return 'https://clairads.com/';
  return '/clairads';
}

export const CLAIRADS_URL = clairAdsHref();
export const CLAIRLABS_URL = isClairAdsHost() ? 'https://clairlabs.io/' : '/';
export const CONTACT_EMAIL = 'partners@clairlabs.io';

export function contactHref(subject) {
  return `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
